import { Button } from '@material-ui/core'
import { Snackbar } from 'elentari'
import React, { useState } from 'react'

const CopyToClipboardButton = ({
  buttonMessage,
  snackbarMessage = 'Copiado com sucesso',
  copyContent,
  autoHideDuration = 2000,
  variant = 'contained',
  color = 'primary',
  fullwidth = false
}) => {
  const [message, setMessage] = useState('')

  const handleClick = () => {
    setMessage(snackbarMessage)
    navigator.clipboard.writeText(copyContent)
  }

  return (
    <>
      <Button
        variant={variant}
        color={color}
        fullWidth={fullwidth}
        onClick={handleClick}
      >
        {buttonMessage}
      </Button>
      <Snackbar
        onClose={() => {
          setMessage('')
        }}
        autoHideDuration={autoHideDuration}
        message={message}
      />
    </>
  )
}

export default CopyToClipboardButton
